module.exports = __webpack_public_path__ + "static/media/1.30041786.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/1.png
// module id = 511
// module chunks = 0